<div class="modal-header m-0" style="background-color: #2563FD; color:white;">
    <h4 class="modal-title">Enviar una sugerencia</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <p>
        Escribanos una sugerencia o comentario para que el equipo de <b>Lubrikuv</b> lo
        considere como feedback. Estos son recibidos y evaluados para futuras actualizaciones.
    </p>
    <p>
        Agradecemos enormemente tu feedback para continuar mejorando <b>Lubrikuv</b> para ti.
    </p>
    <br>
    <form [formGroup]="form">
        <div class="row mb-3">
            <div class="col-12 col-sm">
                <label for="titulo">Título:</label>
                <input type="text" class="form-control" id="titulo" formControlName="titulo"
                    [ngClass]="{'is-invalid': form.controls['titulo'].errors && form.controls['titulo'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo.
                </div>
                <div class="mb-4"
                    *ngIf="!form.controls['titulo'].errors || !(form.controls['titulo'].dirty || form.controls['titulo'].touched)">
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12 col-sm">
                <label for="texto">Sugerencia:</label>
                <textarea class="form-control" id="texto" rows="6" formControlName="texto"
                    [ngClass]="{'is-invalid': form.controls['texto'].errors && form.controls['texto'].touched}"></textarea>
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo.
                </div>
                <div class="mb-4"
                    *ngIf="!form.controls['texto'].errors || !(form.controls['texto'].dirty || form.controls['texto'].touched)">
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="guardar()"><i class="fas fa-comment me-2"></i>Enviar
        Sugerencia
    </button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Cancelar
    </button>
</div>